module.exports = __webpack_public_path__ + "img/Blast_Off_Club_House45.69df22e8.jpg";